import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star } from "lucide-react";

/** value: [{name, priority}] — click chip to toggle, click star to set primary */
export function ProfessionPicker({ value = [], onChange }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    api.get("/professions").then(({ data }) => setOptions(data)).catch((err) => console.warn("Failed to load professions", err));
  }, []);

  const selectedNames = value.map((p) => p.name);

  const toggle = (name) => {
    if (selectedNames.includes(name)) {
      const next = value.filter((p) => p.name !== name);
      if (next.length && !next.some((p) => p.priority === "primary")) next[0] = { ...next[0], priority: "primary" };
      onChange(next);
    } else {
      onChange([...value, { name, priority: value.length === 0 ? "primary" : "secondary" }]);
    }
  };

  const setPrimary = (name, e) => {
    e.stopPropagation();
    onChange(value.map((p) => ({ ...p, priority: p.name === name ? "primary" : "secondary" })));
  };

  return (
    <div data-testid="profession-picker">
      <div className="flex flex-wrap gap-2">
        {options.map((o) => {
          const sel = value.find((p) => p.name === o.name);
          return (
            <button
              key={o.id}
              type="button"
              onClick={() => toggle(o.name)}
              className={`px-3 py-1.5 text-xs font-medium border transition-colors inline-flex items-center gap-1.5 ${
                sel ? "bg-[#1E3F33] text-white border-[#1E3F33]" : "bg-white text-[#1A1E1C] border-[#E2E4E2] hover:border-[#1E3F33]"
              }`}
              data-testid={`prof-chip-${o.name.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
            >
              {o.name}
              {sel && (
                <Star
                  onClick={(e) => setPrimary(o.name, e)}
                  className={`w-3.5 h-3.5 cursor-pointer ${sel.priority === "primary" ? "fill-[#F2C94C] text-[#F2C94C]" : "text-white/60 hover:text-white"}`}
                  title={sel.priority === "primary" ? "Primary profession" : "Set as primary"}
                />
              )}
            </button>
          );
        })}
      </div>
      {value.length > 0 && (
        <p className="text-xs text-[#68706B] mt-2">
          <Star className="w-3 h-3 inline fill-[#F2C94C] text-[#F2C94C]" /> = primary. Tap the star on a selected chip to change your primary profession.
        </p>
      )}
    </div>
  );
}
